module.exports = "/_next/static/images/aftonbladet-badge-828990d0336b25135771506f0670a926.png";